import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    
    <polygon points="50,10.52 61.66,35.53 89.06,38.89 68.87,57.72 74.14,84.81 50,71.43 25.86,84.81 31.13,57.72 10.95,38.89 38.34,35.53 "/>

</svg>